export enum GoogleAnalyticsTrackingId {
  DEV = 'G-YZ8HTNN14S',
  PROD = 'G-V581RYHFK6'
}
